import * as React from "react";

const BookIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M20 22.143H6.5a2.5 2.5 0 0 1-2.5-2.5m0 0v-8.817c0-2.984 0-4.477.757-5.525a4 4 0 0 1 .902-.902c1.048-.757 2.54-.757 5.525-.757.977 0 2.166.052 3.152.065.899.012 1.349.018 2.186-.13.838-.148.927-.182 1.106-.25.77-.293 1.5-.748 2.372-1.184v9.5c0 1.864 0 2.795-.305 3.53a4 4 0 0 1-2.164 2.165c-.735.305-1.667.305-3.531.305H6a2 2 0 0 0-2 2"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M18 17.143v5"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8 4.143v4"
    ></path>
  </svg>
);

export default BookIcon;
